/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {withFormik} from "formik";
import httpService from "../../../../api/httpLocationService";

const SignupForm = (props) => {
  const {
    signUpPath,
    color,
    formAuthToken,
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
    errors,
    values,
  } = props;


  const headerTitle = classNames('sidebar-header arrowed arrowed--o colored--o', {
    'arrowed--b colored--b': color,
  });

  const submitButton = classNames('form-submit', {
    'form-submit__blue': color,
  });

  return (
    <div className="box-shadow order-form__container">
      <div className="sidebar">
        <h3 className={headerTitle}>{I18n.t('provider_signup.form.legend')}</h3>
        <p>
          <strong>
            {I18n.t('provider_signup.form.apply')}
          </strong>
        </p>
        <form
          className="order-form provider-signup"
          acceptCharset="UTF-8"
          onSubmit={handleSubmit}
        >
          <input
            name="authenticity_token"
            value={formAuthToken}
            type="hidden"
          />

          <div className="signup-group">
            <label htmlFor="company">{I18n.t('virtual_office.form.company')}</label>
            <input
              name="company"
              type="text"
              value={values.company}
              onChange={handleChange}
              onBlur={handleBlur}
              className={
                touched.company ? (errors.company ? 'error' : 'is-valid') : null
              }
            />

            <div className="validation-message">
              {touched.company && errors.company ? errors.company : null}
            </div>
          </div>

          <div className="signup-group">
            <label htmlFor="address">
              {I18n.t('provider_signup.form.address')}
            :
            </label>
            <textarea
              name="address"
              value={values.address}
              onChange={handleChange}
              onBlur={handleBlur}
              className={
                touched.address ? (errors.address ? 'error' : 'is-valid') : null
              }
            />
            <div className="validation-message">
              {touched.address && errors.address ? errors.address : null}
            </div>
          </div>
          <div className="signup-group">
            <label htmlFor="zipcode">{I18n.t('provider_signup.form.zipcode')}</label>
            <input
              name="zipcode"
              type="number"
              value={values.zipcode}
              onChange={handleChange}
              onBlur={handleBlur}
              className={
                touched.zipcode ? (errors.zipcode ? 'error' : 'is-valid') : null
              }
            />
            <div className="validation-message">
              {touched.zipcode && errors.zipcode ? errors.zipcode : null}
            </div>
          </div>


          <div className="signup-group">
            <label htmlFor="name">{I18n.t('virtual_office.form.name')}</label>
            <input
              name="name"
              type="text"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              className={
                touched.name ? (errors.name ? 'error' : 'is-valid') : null
              }
            />
            <div className="validation-message">
              {touched.name && errors.name ? errors.name : null}
            </div>

          </div>

          <div className="signup-group">
            <label htmlFor="phone">{I18n.t('virtual_office.form.phone')}</label>
            <input
              name="phone"
              type="tel"
              value={values.phone}
              onChange={handleChange}
              onBlur={handleBlur}
              className={
                touched.phone ? (errors.phone ? 'error' : 'is-valid') : null
              }
            />
            <div className="validation-message">
              {touched.phone && errors.phone ? errors.phone : null}
            </div>
          </div>
          <div className="signup-group">

            <label htmlFor="email">{I18n.t('virtual_office.form.email')}</label>
            <input
              name="email"
              type="text"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              className={
                touched.email ? (errors.email ? 'error' : 'is-valid') : null
              }
            />

            <div className="validation-message">
              {touched.email && errors.email ? errors.email : null}
            </div>
          </div>

          <button
            className={submitButton}
            type="submit"
          >
            {I18n.t('provider_signup.form.submit')}
          </button>
        </form>

      </div>
    </div>
  );
};

SignupForm.propTypes = {
  signUpPath: PropTypes.string,
  color: PropTypes.bool,
  formAuthToken: PropTypes.string,
};

SignupForm.defaultProps = {
  signUpPath: '',
  color: false,
  formAuthToken: '',
};

const SignupFormValidation = withFormik({
  mapPropsToValues: (bag) => ({
    company: '', address: '', zipcode: '', name: '', authenticity_token: bag.formAuthToken, phone: '', email: '',
  }),


  validate: values => {
    let errors = {};
    if (!values.name) {
      errors.name = I18n.t('sidebar.order.form.required-field');
    }
    if (!values.company) {
      errors.company = I18n.t('sidebar.order.form.required-field');
    }

    if (!values.email) {
      errors.email = I18n.t('sidebar.order.form.required-field');
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
        values.email
      )
    ) {
      errors.email = I18n.t('sidebar.order.form.invalid-email');
    }

    if (!values.phone) {
      errors.phone = I18n.t('sidebar.order.form.required-field');
    } else if (
      !/^\+?([\d]*\d){10,}$/i.test(
        values.phone.replace(/[-\s()]/g, '')
      )
    ) {
      errors.phone = I18n.t('sidebar.order.form.invalid-phone');
    }

    if (!values.address) {
      errors.address = I18n.t('sidebar.order.form.required-field');
    }

    if (!values.zipcode) {
      errors.zipcode = I18n.t('sidebar.order.form.required-field');
    }

    return errors;
  },

  handleSubmit: (values, bag) => {
    httpService.signUpForm(values, bag.props.signUpPath, bag.props.formAuthToken)
      .then(() => {
        window.location.replace('/orders/success?type=sign_up');
      });
  },

  displayName: 'SignupForm', // helps with React DevTools
})(SignupForm);

export default SignupFormValidation;

// export default SignupForm;
